export enum BooleanOperator {
    AND,
    OR,
}
